import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'apps/piqet-angular/src/environments/environment';
import { BehaviorSubject, Subject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class DashboardService {
  apiUrl = environment.url;
  private showTourSubject = new BehaviorSubject<boolean>(false);
  showTour$ = this.showTourSubject.asObservable();
  private navigationSubject = new Subject<string>();
  constructor(private http: HttpClient) {}

  getDashboardData() {
    return this.http.get<any>(`${this.apiUrl}/Dashboard/GetDashboardSummary`);
  }

  updateAchievementsVisibility(payload: any) {
    return this.http.post<any>(
      `${this.apiUrl}/Dashboard/UpdateIsShowPersonalAchievement?isShow=${payload}`,
      {}
    );
  }
  navigateToComponent(route: string): void {
    this.navigationSubject.next(route);
  }
  setShowTour(value: boolean) {
    this.showTourSubject.next(value);
  }
}
